<template>
    <div>
        <form @submit.prevent="onSubmit">
            <!-- <v-select name="prize" v-model="entry.prize" :selectValues="[ 'tv', 'speaker', 'keyboard', 'mouse' ]"></v-select> -->
            <v-radio name="gender" v-model="entry.gender" :radioValues="[ 'male', 'female' ]" :radioLabels="[ 'Man', 'Vrouw' ]" tabindexStart="1" ></v-radio>

            <div class="row">
                <div class="col-8">
                    <v-input name="firstname" v-model.trim="entry.firstname" tabindex="3"></v-input>
                </div>
                <div class="col-4">
                    <v-input name="infixname" v-model="entry.infixname" tabindex="4"></v-input>
                </div>
            </div>

            <v-input name="surname" v-model="entry.surname" tabindex="5"></v-input>

            <v-date-of-birth name="date_of_birth" v-model="entry.date_of_birth"></v-date-of-birth>

            <div class="row address-row">
                <div class="col-6">
                    <v-input name="zipcode" v-model="entry.zipcode" @blur="checkAddress" tabindex="9"></v-input>
                </div>
                <div class="col-3">
                    <v-input name="house_num" v-model="entry.house_num" @blur="checkAddress" tabindex="10"></v-input>
                </div>
                <div class="col-3">
                    <v-input name="house_num_add" v-model="entry.house_num_add" @blur="checkAddress" tabindex="11"></v-input>
                </div>
            </div>

            <span class="address-error" v-if="addressError">Dit is geen geldig adres</span>
            <span class="address-preview" v-if="entry.street" >{{ entry.street + ', ' + entry.city }}</span>

            <v-input class="telephone-input" name="telephone" v-model="entry.telephone" tabindex="12"></v-input>
            <p class="small">Vul je telefoonnnummer in en ontvang eenmalig een telefonisch aanbod van Lotto om automatisch mee te spelen.</p>

            <v-input class="email-input" name="emailaddress" v-model="entry.emailaddress" tabindex="13"></v-input>
            <v-checkbox name="kit" v-model="entry.kit" tabindex="14">
                Ja, ik ontvang graag per e-mail interessante acties en aanbiedingen van Lotto.
            </v-checkbox>

            <div class="text-center">
                <button class="black" type="submit" :disabled="waitingForApi" tabindex="15">Verstuur <v-spinner v-if="waitingForApi"></v-spinner></button>

                <p class="disclaimer small">Door op verstuur te drukken ga je akkoord met de <a @click="trackAv" href="/static/pdf/actievoorwaarden.pdf" target="_blank">actievoorwaarden</a> en het&nbsp;<a href="https://www.nederlandseloterij.nl/privacy" target="_blank">Privacy&nbsp;Statement</a></p>
            </div>
        </form>
    </div>
</template>

<style lang="scss" scoped>
    form{
        max-width:500px;
        margin:0 auto;
    }
</style>

<script>
    import Vue from 'vue';
    import { labels } from '@/app/config';
    import { fingerprintjs2, recaptcha, tracking } from '@/app/mixins';

    import CustomInput from '@/app/components/form-elements/CustomInput';
    import CustomCheckbox from '@/app/components/form-elements/CustomCheckbox';
    import CustomRadio from '@/app/components/form-elements/CustomRadio';
    // import CustomSelect from '@/app/components/form-elements/CustomSelect';
    import DateOfBirth from '@/app/components/form-elements/DateOfBirth';
    import Spinner from '@/app/components/Spinner';

    export default {
        components: {
            'v-input': CustomInput,
            'v-checkbox': CustomCheckbox,
            'v-radio': CustomRadio,
            // 'v-select': CustomSelect,
            'v-date-of-birth': DateOfBirth,
            'v-spinner': Spinner
        },

        mixins: [ fingerprintjs2, recaptcha, tracking ],

        data()
        {
            return {
                entry: {
                    gender: null,
                    firstname: null,
                    infixname: null,
                    surname: null,
                    date_of_birth: null,
                    zipcode: null,
                    street: null,
                    city: null,
                    house_num: null,
                    house_num_add: null,
                    telephone: null,
                    emailaddress: null,
                    kit: false
                },

                waitingForApi: false,
                addressError: false
            };
        },

        computed: {
            previousEntry()
            {
                return this.$store.getters['entry/get'];
            },

            score()
            {
                return this.$store.getters[ 'game/score' ];
            },

            bonuses()
            {
                return this.$store.getters[ 'game/bonuses' ];
            }
        },

        watch: {
            'entry.zipcode': function( pVal )
            {
                pVal = pVal.toUpperCase();
                this.entry.zipcode = pVal;
            },

            'entry.telephone': function( pVal )
            {
                pVal = pVal.replace( /[-\s]/g, '' );
                pVal = pVal.replace( /^(\+31)/g, '0' );
                pVal = pVal.replace( /^(0031)/g, '0' );

                this.entry.telephone = pVal;
            }
        },

        mounted()
        {
            this.prizeMoney = this.$store.getters['game/prize'];
        },

        methods: {
            validate()
            {
                return this.$validator.validateAll( Object.keys( this.entry ) ).then( result =>
                {
                    // console.log( result, this.$validator.errors );
                });
            },

            stripSpaces( e )
            {
                this.entry[ e.target.name ] = e.target.value.replace( /[\s ]/g, '' );
                Vue.nextTick( () =>
                {
                    this.$validator.validate( e.target.name, this.entry[ e.target.name ] );
                });
            },

            checkAddress( e )
            {
                this.stripSpaces( e );

                if( !this.entry.zipcode || !this.entry.house_num )
                {
                    return;
                }

                if( this.lastAddress === this.entry.zipcode + this.entry.house_num + this.entry.house_num_add )
                {
                    return;
                }
                this.addressError = false;
                this.lastAddress = this.entry.zipcode + this.entry.house_num + this.entry.house_num_add;
                if( this.entry.zipcode.length > 5 && this.entry.house_num.length > 0 )
                {
                    let url = window._rootData.apiUrl + '/api/address/' + this.entry.zipcode + '/' + this.entry.house_num;
                    if( this.entry.house_num_add && this.entry.house_num_add.length > 0 )
                    {
                        url += '/' + this.entry.house_num_add;
                    }
                    this.waitingForAddress = true;
                    Vue.$http.post( url ).then( ( result ) =>
                    {
                        if( result.data.errorCode )
                        {
                            throw new Error( result.data.message );
                        }
                        this.entry.street = result.data.street;
                        this.entry.city = result.data.city;
                        this.waitingForAddress = false;
                    }).catch( ( result ) =>
                    {
                        this.addressError = true;
                        this.entry.street = null;
                        this.entry.city = null;
                        this.waitingForAddress = false;
                    });
                }
            },

            async onSubmit()
            {
                await this.validate();

                if( !this.$validator.errors.any() )
                {
                    this.waitingForApi = true;

                    this.entry['origin'] = window._rootData.r;
                    this.entry['bonuses'] = this.bonuses.join( ',' );
                    this.entry['score'] = this.score;
                    this.entry['g-recaptcha-response'] = await this.executeRecaptcha();

                    this.$store.dispatch( 'entry/save', this.entry ).then( result =>
                    {
                        this.waitingForApi = false;

                        if( result.id )
                        {
                            this.$emit( 'complete' );
                        }
                    })
                        .catch( error =>
                        {
                            this.waitingForApi = false;

                            for( let field in error.errors )
                            {
                                // console.log( field, labels[ field ], error.errors[ field ][0] );

                                this.$validator.errors.add({
                                    field: field,
                                    msg: error.errors[ field ][0].replace( field, labels[ field ] )
                                });
                            }
                        });
                }
            },

            trackAv()
            {
                this.trackEvent( 'Klik op link - Actievoorwaarden', 'Link tracking', window.location.origin + '/static/pdf/actievoorwaarden.pdf' );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/Form.vue